(function ($) {
  $(".hamburger-button button").on("click", function () {
    $("body").toggleClass("nav-open");
  });

  $(document).on("click", function (e) {
    if (
      !$(e.target).closest(".hamburger-button").length &&
      $("body").hasClass("nav-open")
    ) {
      $("body").removeClass("nav-open");
    }
  });
})(jQuery);
